/**
 * CLICKAR.BIZ INTERNATIONAL REST API
 * APIs Clickar.biz international.
 *
 * OpenAPI spec version: API V1
 * Contact: blureply@reply.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable, Optional } from "@angular/core";
import { environment } from "@app/../environments/environment";
import { HeaderKey } from "@shared/clickar-constants";
import { EnableAuctioneerDTO, MultiAuctioneerTemplateEnableDTO } from "@shared/model/auctioneer.model";
import { Dealer, DealerInfoDTO, DealerInternalReferenceDTO } from "@shared/model/dealer.model";
import { DacDealerDTO, DealerAdminDTO } from "@shared/model/dealerAdminDTO";
import { EmailDTO } from "@shared/model/emailDTO";
import { EnableDealerDTO } from "@shared/model/enableDealerDTO";
import { EnableExhibitorDTO, ExhibitorDTO } from "@shared/model/exhibitor.model";
import { LeadDTO } from "@shared/model/leadDTO";
import { PushNotificationDTO } from "@shared/model/pushNotificationDTO";
import { AssociateSellerDTO, MarketSellerConfig, SellerDTO } from "@shared/model/seller.model";
import { ShowcaseBuyerDTO } from "@shared/model/showcase.model";
import { EnableTemplateDTO, TemplateAdminDTO, TemplateBuyerDTO, TemplateDTO, TemplateInfoDTO } from "@shared/model/template.model";
import { TopCms } from "@shared/model/top-cms";
import {
	NewUserEmailDTO,
	PermissionDTO,
	UserBuyerSearchDTO,
	UserBuyerTemplateDTO,
	UserDTO,
	UsersBuyerSearchParamsDTO
} from "@shared/model/user.model";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";
import { Configuration } from "@shared/services/utils/configuration";
import { CustomHttpUrlEncodingCodec } from "@shared/services/utils/encoder";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";


@Injectable()
export class AdminService {
	protected basePath = "http://localhost:8088";
    protected k8sPath = 'https://localhost:8088';

    defaultHeaders = new HttpHeaders();
	configuration = new Configuration();
	readonly encoderParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

	constructor(private utils: ClickarUtilsService, protected httpClient: HttpClient, @Optional() configuration: Configuration) {
		this.basePath = environment.baseApiUrl;
        this.k8sPath = environment.k8sApiUrl;


        if (configuration) {
			this.configuration = configuration;
			this.basePath = environment.baseApiUrl || configuration.basePath || this.basePath;
		}
	}

	enableDealerUsingPUT(enableDealerDTO: EnableDealerDTO, observe?: "body", reportProgress?: boolean): Observable<any> {

		return this.httpClient.put<any>(`${this.basePath}/api/v1/admin/enable-dealer`,
			enableDealerDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getDealerInfoUsingGET(idDealer?: number, idMarket?: string, businessName?: string, city?: string, country?: string, createFrom?: Date, createTo?: Date, dealerId?: number, email?: string, flgIam?: boolean, limit?: number, offset?: number, postalCode?: string, region?: string, username?: string, vatCode?: string, vatCodes?: string[], observe?: "body", reportProgress?: boolean): Observable<DealerInfoDTO[]> {
		let queryParameters = this.encoderParameters;

		if (businessName !== undefined && businessName !== null) {
			queryParameters = queryParameters.set("businessName", <any>businessName);
		}
		if (city !== undefined && city !== null) {
			queryParameters = queryParameters.set("city", <any>city);
		}
		if (country !== undefined && country !== null) {
			queryParameters = queryParameters.set("country", <any>country);
		}
		if (createFrom !== undefined && createFrom !== null) {
			queryParameters = queryParameters.set("createFrom", <any>createFrom.toISOString());
		}
		if (createTo !== undefined && createTo !== null) {
			queryParameters = queryParameters.set("createTo", <any>createTo.toISOString());
		}
		if (dealerId !== undefined && dealerId !== null) {
			queryParameters = queryParameters.set("dealerId", <any>dealerId);
		}
		if (email !== undefined && email !== null) {
			queryParameters = queryParameters.set("email", <any>email);
		}
		if (flgIam !== undefined && flgIam !== null) {
			queryParameters = queryParameters.set("flgIam", <any>flgIam);
		}
		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}
		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("idMarket", <any>idMarket);
		}
		if (limit !== undefined && limit !== null) {
			queryParameters = queryParameters.set("limit", <any>limit);
		}
		if (offset !== undefined && offset !== null) {
			queryParameters = queryParameters.set("offset", <any>offset);
		}
		if (postalCode !== undefined && postalCode !== null) {
			queryParameters = queryParameters.set("postalCode", <any>postalCode);
		}
		if (region !== undefined && region !== null) {
			queryParameters = queryParameters.set("region", <any>region);
		}
		if (username !== undefined && username !== null) {
			queryParameters = queryParameters.set("username", <any>username);
		}
		if (vatCode !== undefined && vatCode !== null) {
			queryParameters = queryParameters.set("vatCode", <any>vatCode);
		}
		if (vatCodes) {
			for (const element of vatCodes) {
				queryParameters = queryParameters.append("vatCodes", <any>element);
			}
		}

		return this.httpClient.get<DealerInfoDTO[]>(`${this.basePath}/api/v1/admin/dealers-info/search`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	exportDealerToConfigureUsingGET(observe?: "body", reportProgress?: boolean): Observable<any> {
		const headers = this.defaultHeaders.set("Accept", "text/csv; charset=utf-8"),
			requestOptions: any = {
				/* other options here */
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress,
				responseType: "text"
			};

		return this.httpClient.get<any>(`${this.basePath}/api/v1/admin/dealer-to-configure/export`,
			requestOptions
		);
	}

	exportUserToAnonymizeGET(idMarket: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		let headers = this.defaultHeaders,
			queryParameters = this.encoderParameters;

		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("idMarket", <any>idMarket);
		}
		headers = headers.set("Accept", "text/csv; charset=utf-8");

		const requestOptions: any = {
			params: queryParameters,
			withCredentials: this.configuration.withCredentials,
			headers,
			observe,
			reportProgress,
			responseType: "text"
		};

		return this.httpClient.get<any>(`${this.basePath}/api/v1/admin/user/anonymize/export`,
			requestOptions
		);
	}

	createReportUsingGET(from?: Date, idAuction?: number, idDealer?: number, idMarket?: string, idTemplate?: number, loginType?: string, reportType?: string, to?: Date, username?: string, vatCode?: string, templateName?: string, auctionName?: string, flgDeleted?: boolean, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (from !== undefined && from !== null && !this.utils.isEmpty(from)) {
			queryParameters = queryParameters.set("from", <any>from);
		}
		if (idAuction !== undefined && idAuction !== null) {
			queryParameters = queryParameters.set("idAuction", <any>idAuction);
		}
		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}
		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("idMarket", <any>idMarket);
		}
		if (idTemplate !== undefined && idTemplate !== null) {
			queryParameters = queryParameters.set("idTemplate", <any>idTemplate);
		}
		if (loginType !== undefined && loginType !== null) {
			queryParameters = queryParameters.set("loginType", <any>loginType);
		}
		if (reportType !== undefined && reportType !== null) {
			queryParameters = queryParameters.set("reportType", <any>reportType);
		}
		if (to !== undefined && to !== null && !this.utils.isEmpty(to)) {
			queryParameters = queryParameters.set("to", <any>to);
		}
		if (username !== undefined && username !== null) {
			queryParameters = queryParameters.set("username", <any>username);
		}
		if (vatCode !== undefined && vatCode !== null) {
			queryParameters = queryParameters.set("vatCode", <any>vatCode);
		}
		if (templateName !== undefined && templateName !== null) {
			queryParameters = queryParameters.set("templateName", <any>templateName);
		}
		if (auctionName !== undefined && auctionName !== null) {
			queryParameters = queryParameters.set("auctionName", <any>auctionName);
		}
		if (flgDeleted !== undefined && flgDeleted !== null) {
			queryParameters = queryParameters.set("flgDeleted", <any>flgDeleted);
		}

		const headers = this.defaultHeaders.set("Accept", "text/csv; charset=utf-8"),
			requestOptions: any = {
				/* other options here */
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress,
				responseType: "text"
			};

		return this.httpClient.get<any>(`${this.k8sPath}/api/v1/admin/report`,
			requestOptions
		);
	}

	getUserUsingGET(idUser: number, observe?: "body", reportProgress?: boolean): Observable<UserDTO> {
		let queryParameters = this.encoderParameters;

		if (idUser !== undefined && idUser !== null) {
			queryParameters = queryParameters.set("idUser", <any>idUser);
		}

		return this.httpClient.get<UserDTO>(`${this.basePath}/api/v1/admin/user`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}


	getTopCmsGET(idMarket: string, observe?: "body", reportProgress?: boolean): Observable<TopCms[]> {
		let queryParameters = this.encoderParameters;

		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("mkt", <any>idMarket);
		}

		return this.httpClient.get<TopCms[]>(
			`${this.basePath}/api/v1/admin/top-cms`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		).pipe(map(b => (b || [])
			.map(c => {
				c = Object.assign(new TopCms(), c);
				c.setImage(c.image);
				c.setImage(c.imageTablet, "Tablet");
				c.setImage(c.imageMobile, "Mobile");
				return c;
			}))
		);
	}

	postTopCms = (top: TopCms, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.post<any>(`${this.basePath}/api/v1/admin/top-cms`,
			top,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	putTopCms = (top: TopCms, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.put<any>(`${this.basePath}/api/v1/admin/top-cms`,
			top,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	deleteTopCms(id: number, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (id !== undefined && id !== null) {
			queryParameters = queryParameters.set("id", <any>id);
		}

		return this.httpClient.delete<any>(`${this.basePath}/api/v1/admin/top-cms`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	editUserUsingPUT = (user: UserDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.put<any>(`${this.basePath}/api/v1/admin/user`,
			user,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	getBuyerShowcaseUsingGET(iduser: number, observe?: "body", reportProgress?: boolean): Observable<ShowcaseBuyerDTO[]> {
		let queryParameters = this.encoderParameters;

		if (iduser !== undefined && iduser !== null) {
			queryParameters = queryParameters.set("iduser", <any>iduser);
		}

		return this.httpClient.get<ShowcaseBuyerDTO[]>(`${this.basePath}/api/v1/admin/user-buyer-showcase`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	putBuyerShowcaseUsingPUT = (buyerShowcases: ShowcaseBuyerDTO[], observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.put<any>(`${this.basePath}/api/v1/admin/user-buyer-showcase`,
			buyerShowcases,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	getSellerByMarketUsingGET(market: string, observe?: "body", reportProgress?: boolean): Observable<SellerDTO[]> {

		let queryParameters = this.encoderParameters;

		if (market !== undefined && market !== null) {
			queryParameters = queryParameters.set("market", <any>market);
		}

		return this.httpClient.get<SellerDTO[]>(`${this.basePath}/api/v1/admin/seller-market`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getSellerByIdUsingGET(idSeller: number, observe?: "body", reportProgress?: boolean): Observable<SellerDTO> {
		let queryParameters = this.encoderParameters;

		if (idSeller !== undefined && idSeller !== null) {
			queryParameters = queryParameters.set("idSeller", <any>idSeller);
		}
		return this.httpClient.get<SellerDTO>(`${this.basePath}/api/v1/admin/seller`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	putSellerUsingPUT(sellerDTO: SellerDTO, observe?: "body", reportProgress?: boolean): Observable<any> {
		return this.httpClient.put<any>(`${this.basePath}/api/v1/admin/seller`,
			sellerDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getSelectedCarSoldByMarketUsingGET(market: string, observe?: "body", reportProgress?: boolean): Observable<string[]> {
		let queryParameters = this.encoderParameters;

		if (market !== undefined && market !== null) {
			queryParameters = queryParameters.set("market", <any>market);
		}

		return this.httpClient.get<string[]>(`${this.basePath}/api/v1/admin/selected-car-sold`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}


	getSelectAreasByMarketUsingGET(market: string, observe?: "body", reportProgress?: boolean): Observable<string[]> {
		let queryParameters = this.encoderParameters;

		if (market !== undefined && market !== null) {
			queryParameters = queryParameters.set("market", <any>market);
		}

		return this.httpClient.get<string[]>(`${this.basePath}/api/v1/admin/selected-seller-area`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	postSellerUsingPOST(sellerDTO: SellerDTO, observe?: "body", reportProgress?: boolean): Observable<any> {
		return this.httpClient.post<any>(`${this.basePath}/api/v1/admin/seller`,
			sellerDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getSellerConfigUsingGET(market: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (market !== undefined && market !== null) {
			queryParameters = queryParameters.set("market", <any>market);
		}

		return this.httpClient.get<any>(`${this.basePath}/api/v1/admin/seller-config`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	postSellerConfigUsingPOST(config: MarketSellerConfig, observe?: "body", reportProgress?: boolean): Observable<any> {
		return this.httpClient.post<any>(`${this.basePath}/api/v1/admin/seller-config`,
			config,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getBuyerTemplate(iduser: number, observe?: "body", reportProgress?: boolean): Observable<TemplateBuyerDTO[]> {

		let queryParameters = this.encoderParameters;

		if (iduser !== undefined && iduser !== null) {
			queryParameters = queryParameters.set("iduser", <any>iduser);
		}

		return this.httpClient.get<TemplateBuyerDTO[]>(`${this.basePath}/api/v1/admin/user-buyer-template`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	putBuyerTemplateUsingPUT(buyerTemplates: TemplateBuyerDTO[], observe?: "body", reportProgress?: boolean): Observable<any> {

		return this.httpClient.put<any>(`${this.basePath}/api/v1/admin/user-buyer-template`,
			buyerTemplates,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getDealerToConfigureCountUsingGET(observe?: "body", reportProgress?: boolean): Observable<number> {

		return this.httpClient.get<number>(`${this.basePath}/api/v1/admin/dealer-to-configure-count`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	createDealerUsingPOST(dealerFull: DealerAdminDTO, observe?: "body", reportProgress?: boolean): Observable<any> {

		return this.httpClient.post<any>(`${this.basePath}/api/v1/admin/dealer`,
			dealerFull,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	deleteSellerUsingDELETE(sellerDTO: number, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (sellerDTO !== undefined && sellerDTO !== null) {
			queryParameters = queryParameters.set("idSeller", <any>sellerDTO);
		}

		return this.httpClient.delete<any>(`${this.basePath}/api/v1/admin/seller`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getDealerDacUsingGET(vatCode?: string, observe?: "body", reportProgress?: boolean): Observable<DacDealerDTO[]> {
		let queryParameters = this.encoderParameters;

		if (vatCode !== undefined && vatCode !== null) {
			queryParameters = queryParameters.set("vatCode", <any>vatCode);
		}

		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<DacDealerDTO[]>(`${this.basePath}/api/v1/admin/dealer/dac`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	getDealerToConfigureUsingGET(observe?: "body", reportProgress?: boolean): Observable<Dealer[]> {
		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<Dealer[]>(`${this.basePath}/api/v1/admin/dealer-to-configure`,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	getSellerDealerUsingGET(idDealer: number, observe?: "body", reportProgress?: boolean): Observable<SellerDTO[]> {
		let queryParameters = this.encoderParameters;

		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}

		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<SellerDTO[]>(`${this.basePath}/api/v1/admin/reference-seller-dealer`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	associateSellerUsingPOST(associateDTO: AssociateSellerDTO, observe?: "body", reportProgress?: boolean): Observable<any> {
		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = ["application/json"],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}

		return this.httpClient.post<any>(`${this.basePath}/api/v1/admin/associate-seller-dealer`,
			associateDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	getUserAnonymize(idMarket?: string, limit?: number, offset?: number, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (limit !== undefined && limit !== null) {
			queryParameters = queryParameters.set("limit", <any>limit);
		}
		if (offset !== undefined && offset !== null) {
			queryParameters = queryParameters.set("offset", <any>offset);
		}
		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("idMarket", <any>idMarket);
		}
		return this.httpClient.get<any>(`${this.basePath}/api/v1/admin/user/anonymize`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getDealerUsingGET(businessName?: string, city?: string, country?: string, email?: string, flgIam?: boolean, idDealer?: number, limit?: number, offset?: number, postalCode?: string, region?: string, username?: string, vatCode?: string, createFrom?: string, createTo?: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (businessName !== undefined && businessName !== null) {
			queryParameters = queryParameters.set("businessName", <any>businessName);
		}
		if (city !== undefined && city !== null) {
			queryParameters = queryParameters.set("city", <any>city);
		}
		if (country !== undefined && country !== null) {
			queryParameters = queryParameters.set("country", <any>country);
		}
		if (email !== undefined && email !== null) {
			queryParameters = queryParameters.set("email", <any>email);
		}
		if (flgIam !== undefined && flgIam !== null) {
			queryParameters = queryParameters.set("flgIam", <any>flgIam);
		}
		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}
		if (limit !== undefined && limit !== null) {
			queryParameters = queryParameters.set("limit", <any>limit);
		}
		if (offset !== undefined && offset !== null) {
			queryParameters = queryParameters.set("offset", <any>offset);
		}
		if (postalCode !== undefined && postalCode !== null) {
			queryParameters = queryParameters.set("postalCode", <any>postalCode);
		}
		if (region !== undefined && region !== null) {
			queryParameters = queryParameters.set("region", <any>region);
		}
		if (username !== undefined && username !== null) {
			queryParameters = queryParameters.set("username", <any>username);
		}
		if (vatCode !== undefined && vatCode !== null) {
			queryParameters = queryParameters.set("vatCode", <any>vatCode);
		}
		if (createFrom !== undefined && createFrom !== null && !this.utils.isEmpty(createFrom)) {
			queryParameters = queryParameters.set("createFrom", createFrom);
		}
		if (createTo !== undefined && createTo !== null && !this.utils.isEmpty(createTo)) {
			queryParameters = queryParameters.set("createTo", createTo);
		}

		return this.httpClient.get<any>(`${this.basePath}/api/v1/admin/dealer`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	editDealerUsingPUT = (dealerFull: DealerAdminDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.put<any>(`${this.basePath}/api/v1/admin/dealer`,
			dealerFull,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);


	deleteUserUsingDELETE(idUser: number, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (idUser !== undefined && idUser !== null) {
			queryParameters = queryParameters.set("idUser", <any>idUser);
		}

		return this.httpClient.delete<any>(`${this.basePath}/api/v1/admin/user`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	resetUserPasswordUsingPATCH(idUser: number, observe?: "body", reportProgress?: boolean): Observable<any> {
		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = ["application/json"],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}

		return this.httpClient.patch<any>(`${this.basePath}/api/v1/admin/user/reset-pwd`,
			idUser,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	enableDisableUserUsingPATCH = (enableDealerDTO: EnableDealerDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.patch<any>(`${this.basePath}/api/v1/admin/user/enable-disable`,
			enableDealerDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	deleteDealerUsingDELETE(idDealer: number, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}

		return this.httpClient.delete<any>(`${this.basePath}/api/v1/admin/dealer`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	sendEmailUserUsingPOST = (newUserEmailDTO: NewUserEmailDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.post<any>(`${this.basePath}/api/v1/admin/send-email-user`,
			newUserEmailDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	getAuctioneerUsingGET(businessName?: string, city?: string, country?: string, createFrom?: Date, createTo?: Date, dealerId?: number, email?: string, flgIam?: boolean, idDealer?: number, idMarket?: string, limit?: number, offset?: number, postalCode?: string, region?: string, username?: string, vatCode?: string, observe?: "body", reportProgress?: boolean): Observable<DealerInfoDTO[]> {
		let queryParameters = this.encoderParameters;

		if (businessName !== undefined && businessName !== null) {
			queryParameters = queryParameters.set("businessName", <any>businessName);
		}
		if (city !== undefined && city !== null) {
			queryParameters = queryParameters.set("city", <any>city);
		}
		if (country !== undefined && country !== null) {
			queryParameters = queryParameters.set("country", <any>country);
		}
		if (createFrom !== undefined && createFrom !== null) {
			queryParameters = queryParameters.set("createFrom", <any>createFrom.toISOString());
		}
		if (createTo !== undefined && createTo !== null) {
			queryParameters = queryParameters.set("createTo", <any>createTo.toISOString());
		}
		if (dealerId !== undefined && dealerId !== null) {
			queryParameters = queryParameters.set("dealerId", <any>dealerId);
		}
		if (email !== undefined && email !== null) {
			queryParameters = queryParameters.set("email", <any>email);
		}
		if (flgIam !== undefined && flgIam !== null) {
			queryParameters = queryParameters.set("flgIam", <any>flgIam);
		}
		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}
		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("idMarket", <any>idMarket);
		}
		if (limit !== undefined && limit !== null) {
			queryParameters = queryParameters.set("limit", <any>limit);
		}
		if (offset !== undefined && offset !== null) {
			queryParameters = queryParameters.set("offset", <any>offset);
		}
		if (postalCode !== undefined && postalCode !== null) {
			queryParameters = queryParameters.set("postalCode", <any>postalCode);
		}
		if (region !== undefined && region !== null) {
			queryParameters = queryParameters.set("region", <any>region);
		}
		if (username !== undefined && username !== null) {
			queryParameters = queryParameters.set("username", <any>username);
		}
		if (vatCode !== undefined && vatCode !== null) {
			queryParameters = queryParameters.set("vatCode", <any>vatCode);
		}

		return this.httpClient.get<DealerInfoDTO[]>(`${this.basePath}/api/v1/admin/auctioneer`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	addPermissionUsingPOST = (permission: PermissionDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.post<any>(`${this.basePath}/api/v1/admin/user/permission`,
			permission,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	deletePermissionUsingDELETE(permission: string, userID: number, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (permission !== undefined && permission !== null) {
			queryParameters = queryParameters.set("permission", <any>permission);
		}
		if (userID !== undefined && userID !== null) {
			queryParameters = queryParameters.set("userID", <any>userID);
		}

		return this.httpClient.delete<any>(`${this.basePath}/api/v1/admin/user/permission`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getDealerReferenceUsingGET(idDealer: number, observe?: "body", reportProgress?: boolean): Observable<DealerInternalReferenceDTO> {
		let queryParameters = this.encoderParameters;

		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}

		return this.httpClient.get<DealerInternalReferenceDTO>(`${this.basePath}/api/v1/admin/dealer-reference`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	enableExhibitorUsingPUT = (enableAuctioneerDTO: EnableExhibitorDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.put<any>(`${this.basePath}/api/v1/admin/enable-exhibitor`,
			enableAuctioneerDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	getExhibitorUsingGET(businessName?: string, city?: string, country?: string, createFrom?: Date, createTo?: Date, dealerId?: number, email?: string, flgIam?: boolean, idDealer?: number, idMarket?: string, limit?: number, offset?: number, postalCode?: string, region?: string, username?: string, vatCode?: string, observe?: "body", reportProgress?: boolean): Observable<ExhibitorDTO[]> {
		let queryParameters = this.encoderParameters;

		if (businessName !== undefined && businessName !== null) {
			queryParameters = queryParameters.set("businessName", <any>businessName);
		}
		if (city !== undefined && city !== null) {
			queryParameters = queryParameters.set("city", <any>city);
		}
		if (country !== undefined && country !== null) {
			queryParameters = queryParameters.set("country", <any>country);
		}
		if (createFrom !== undefined && createFrom !== null) {
			queryParameters = queryParameters.set("createFrom", <any>createFrom.toISOString());
		}
		if (createTo !== undefined && createTo !== null) {
			queryParameters = queryParameters.set("createTo", <any>createTo.toISOString());
		}
		if (dealerId !== undefined && dealerId !== null) {
			queryParameters = queryParameters.set("dealerId", <any>dealerId);
		}
		if (email !== undefined && email !== null) {
			queryParameters = queryParameters.set("email", <any>email);
		}
		if (flgIam !== undefined && flgIam !== null) {
			queryParameters = queryParameters.set("flgIam", <any>flgIam);
		}
		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}
		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("idMarket", <any>idMarket);
		}
		if (limit !== undefined && limit !== null) {
			queryParameters = queryParameters.set("limit", <any>limit);
		}
		if (offset !== undefined && offset !== null) {
			queryParameters = queryParameters.set("offset", <any>offset);
		}
		if (postalCode !== undefined && postalCode !== null) {
			queryParameters = queryParameters.set("postalCode", <any>postalCode);
		}
		if (region !== undefined && region !== null) {
			queryParameters = queryParameters.set("region", <any>region);
		}
		if (username !== undefined && username !== null) {
			queryParameters = queryParameters.set("username", <any>username);
		}
		if (vatCode !== undefined && vatCode !== null) {
			queryParameters = queryParameters.set("vatCode", <any>vatCode);
		}

		return this.httpClient.get<ExhibitorDTO[]>(`${this.basePath}/api/v1/admin/exhibitor`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getTemplate
	 *
	 * @param userId userId
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getTemplateUsingGET(idDealer?: number, observe?: "body", reportProgress?: boolean): Observable<TemplateAdminDTO[]>;
	getTemplateUsingGET(idDealer?: number, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<TemplateAdminDTO[]>>;
	getTemplateUsingGET(idDealer?: number, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<TemplateAdminDTO[]>>;
	getTemplateUsingGET(idDealer?: number, observe: any = "body", reportProgress = false): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}

		return this.httpClient.get<TemplateDTO[]>(`${this.basePath}/api/v1/admin/template`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}


	enableTemplateUsingPUT = (enableTemplateDTO: EnableTemplateDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.put<any>(`${this.basePath}/api/v1/admin/enable-template`,
			enableTemplateDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	enableAuctioneerUsingPUT = (enableAuctioneerDTO: EnableAuctioneerDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.put<any>(`${this.basePath}/api/v1/admin/enable-auctioneer`,
			enableAuctioneerDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	getLeadUsingPOST = (observe?: "body", reportProgress?: boolean): Observable<LeadDTO[]> =>
		this.httpClient.post<LeadDTO[]>(`${this.basePath}/api/v1/admin/lead`,
			null,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	sendEmailUsingPOST = (emailDTO: EmailDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.post<any>(`${this.basePath}/api/v1/admin/email`,
			emailDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);


	getDealersAuctioneerUsingPOST(market: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (market !== undefined && market !== null) {
			queryParameters = queryParameters.set("market", <any>market);
		}

		return this.httpClient.get<any>(`${this.basePath}/api/v1/admin/dealer-auctioneer`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}


	getMarketTemplateUsingPUT(market: string, observe?: "body", reportProgress?: boolean): Observable<TemplateInfoDTO[]> {
		let queryParameters = this.encoderParameters;

		if (market !== undefined && market !== null) {
			queryParameters = queryParameters.set("market", <any>market);
		}

		return this.httpClient.put<TemplateInfoDTO[]>(`${this.basePath}/api/v1/admin/market-template`,
			null,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}


	getwithPostUsersBuyerByTemplateUsingPOST(params: UsersBuyerSearchParamsDTO, observe?: "body", reportProgress?: boolean): Observable<UserBuyerTemplateDTO[]> {
		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected)
				.set(HeaderKey.NO_SUCCESS_POPUP, "true");
		}

		// to determine the Content-Type header
		const consumes: string[] = ["application/json"],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}

		return this.httpClient.post<UserBuyerTemplateDTO[]>(`${this.k8sPath}/api/v1/admin/users-buyer-template`,
			params,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	getUsersBuyerByTemplateUsingGET(params: UsersBuyerSearchParamsDTO, observe?: "body", reportProgress?: boolean): Observable<UserBuyerTemplateDTO[]> {
		let queryParameters = this.encoderParameters;

		if (params.accepted !== undefined && params.accepted !== null) {
			queryParameters = queryParameters.set("accepted", <any>params.accepted);
		}
		if (params.blockedUser !== undefined && params.blockedUser !== null) {
			queryParameters = queryParameters.set("blockedUser", <any>params.blockedUser);
		}
		if (params.fcaUser !== undefined && params.fcaUser !== null) {
			queryParameters = queryParameters.set("fcaUser", <any>params.fcaUser);
		}
		if (params.idTemplate !== undefined && params.idTemplate !== null) {
			queryParameters = queryParameters.set("idTemplate", <any>params.idTemplate);
		}
		if (params.market !== undefined && params.market !== null) {
			queryParameters = queryParameters.set("market", <any>params.market);
		}
		if (params.province !== undefined && params.province !== null) {
			queryParameters = queryParameters.set("province", <any>params.province);
		}
		if (params.vatCode !== undefined && params.vatCode !== null) {
			queryParameters = queryParameters.set("vatCode", <any>params.vatCode);
		}

		let headers = this.defaultHeaders;

		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<UserBuyerTemplateDTO[]>(`${this.k8sPath}/api/v1/admin/users-buyer-template`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	sendPushNotificationUsingPOST = (pushNotificationDTO: PushNotificationDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.post<any>(`${this.basePath}/api/v1/admin/push-notification`,
			pushNotificationDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);



	getLeadUsingGET = (observe?: "body", reportProgress?: boolean): Observable<LeadDTO[]> =>
		this.httpClient.get<LeadDTO[]>(`${this.basePath}/api/v1/admin/lead`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	sendLeadUsingPATCH = (observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.patch<any>(`${this.basePath}/api/v1/admin/lead`,
			null,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	exportUsersBuyerByTemplate(params: UserBuyerSearchDTO, observe?: "body", reportProgress?: boolean): Observable<any[]> {
		let queryParameters = this.encoderParameters;

		if (params !== undefined && params !== null) {

			queryParameters = queryParameters.set("market", <any>params.market)
				.set("idTemplate", <any>params.idTemplate);
			if (params.vatCode) {
				queryParameters = queryParameters.set("vatCode", <any>params.vatCode);
			}
			if (params.province) {
				queryParameters = queryParameters.set("province", <any>params.province);
			}
			if (params.fcaUser) {
				queryParameters = queryParameters.set("fcaUser", <any>params.fcaUser);
			}
			if (params.blockedUser) {
				queryParameters = queryParameters.set("blockedUser", <any>params.blockedUser);
			}
		}

		const headers = this.defaultHeaders.set("Accept", "text/csv; charset=utf-8"),
			requestOptions: object = {
				/* other options here */
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress,
				responseType: "text"
			};

		return this.httpClient.get<any>(`${this.basePath}/api/v1/admin/export-buyers`,
			requestOptions
		);
	}

	editUsersBuyerByTemplateUsingPUT = (params: UserBuyerSearchDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.put<any>(`${this.basePath}/api/v1/admin/users-buyer-template`,
			params,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);


	enableMultiAuctioneerUsingPUT = (enableAuctioneerDTO: EnableAuctioneerDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.put<any>(`${this.basePath}/api/v1/admin/enable-multi-auctioneer`,
			enableAuctioneerDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	getMultiAuctioneerTemplatesUsingGET(idDealer: number, observe?: "body", reportProgress?: boolean): Observable<TemplateInfoDTO[]> {
		let queryParameters = this.encoderParameters;

		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}

		return this.httpClient.get<TemplateInfoDTO[]>(`${this.basePath}/api/v1/admin/multi-auctioneer-template`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	addMultiAuctioneerTemplateToDealerUsingPOST = (dto: MultiAuctioneerTemplateEnableDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.post<any>(`${this.basePath}/api/v1/admin/multi-auctioneer-template`,
			dto,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	deleteMultiAuctioneerTemplateToDealerUsingDELETE(idDealer: number, idTemplate: number, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}
		if (idTemplate !== undefined && idTemplate !== null) {
			queryParameters = queryParameters.set("idTemplate", <any>idTemplate);
		}

		return this.httpClient.delete<any>(`${this.basePath}/api/v1/admin/multi-auctioneer-template`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getAvailableTemplatesByMarketUsingGET(idDealer: number, market: string, observe?: "body", reportProgress?: boolean): Observable<TemplateInfoDTO[]> {
		let queryParameters = this.encoderParameters;

		if (market !== undefined && market !== null) {
			queryParameters = queryParameters.set("market", <any>market)
				.set("idDealer", <any>idDealer);
		}

		return this.httpClient.get<TemplateInfoDTO[]>(`${this.basePath}/api/v1/admin/market-template`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	anonymizeUser(users: any[], observe?: "body", reportProgress?: boolean): Observable<any> {

		return this.httpClient.put<any>(`${this.basePath}/api/v1/admin/user/anonymize`,
			users,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}
}